import { gql, useQuery } from "@apollo/client"
import { enablePreview, client } from "../../graphql/contentful/client"
import { ArticleModel } from "../../components/contentful/models"
import { ContentfulEntryTypeName } from "../../components/contentful/entries"

export interface ArticleQuery {
  articleCollection: {
    items: ArticleModel<ContentfulEntryTypeName>[]
  }
}

const LINK_ENTRIES = `
entries {
  block {
    sys {
      id
    }
    __typename
    ... on TestQuote {
      author
      text
      title
    }
      ... on FeatureHighlight {
      title
      content
    }
    ... on LogoShowcase {
      title
      logosCollection {
        items {
          url
          description
        }
      }
    }
    ... on Metadata {
      relatedLinks
    }
  }
}
`

const LINK_ASSETS = `
assets {
  block {
    sys {
      id
    }
    url(transform: { format: WEBP, width: 900, quality: 70 })
    description
  }
}
`

export const RICH_TEXT_CONTENT = `
content {
  json
  links {
    ${LINK_ENTRIES}
    ${LINK_ASSETS}
  }
}
`

export const QUERY_ARTICLE = gql`
  query getContentfulArticle($slug: String!, $preview: Boolean) {
    articleCollection(where: { slug: $slug }, limit: 1, preview: $preview) {
      __typename
      items {
        __typename
        sys {
          id
          firstPublishedAt
          publishedAt
        }
        title
        header {
          __typename
          url(transform: { format: WEBP, width: 2400, quality: 70 })
          sys {
            id
          }
        }
        tags
        description
        ${RICH_TEXT_CONTENT}
      }
    }
  }
`
export function useArticle(slug: string) {
  const { data, loading, error } = useQuery<ArticleQuery>(QUERY_ARTICLE, {
    client: client,
    variables: {
      slug,
      preview: enablePreview,
    },
  })

  const article = data?.articleCollection.items[0]

  return { article, loading, error, query: QUERY_ARTICLE }
}
